// src/pages/Login.jsx
import React, { useState } from 'react';
import firebase from '../db/firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { Eye, EyeOff } from 'lucide-react'; 
import Logo from '../assets/icons/logo.svg'; 
import Car from '../assets/icons/car.svg';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setMsg('');

    try {
      const res = await signInWithEmailAndPassword(firebase.auth, email, password);

      if (res.user.email !== 'admin@mcnally.com') {
        setMsg('Access denied: This user is not authorised.');
        return;
      }

      setMsg('Successfully signed in. Welcome!');
    } catch (error) {
      setMsg('Sign-in failed: Incorrect email or password.');
    }
  };

  return (
    <div className="flex flex-1 items-center justify-center min-h-screen bg-blueBlack relative">
      <form
        onSubmit={handleLogin}
        className="bg-[#476C73] text-black p-8 rounded-2xl shadow-xl w-full max-w-sm z-10"
      > 
        <img src={Logo} alt="Logo" className="w-24 h-24 mx-auto mb-4" />
        <h2 className="text-2xl font-bold mb-6 text-center text-white">Admin Login</h2>

        <input
          type="email"
          placeholder="Email"
          className="w-full p-2 mb-4 border rounded"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <div className="relative mb-4">
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Password"
            className="w-full p-2 border rounded pr-10"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute inset-y-0 right-2 flex items-center text-gray-600 hover:text-black"
            tabIndex={-1}
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>

        <button
          type="submit"
          className="w-full bg-[#5298A8] text-white py-2 rounded hover:bg-[#417d8f] transition"
        >
          Log In
        </button>

        {msg && <p className="mt-4 text-sm text-center">{msg}</p>}
      </form>
      <img src={Car} alt="Logo" className="w-[300px] h-[300px] absolute right-[2%] bottom-[2%]  " />

    </div>
  );
};

export default Login;